import { useContentResource } from "@ctv/core";
import { Button, Card, Modal, Text, Token, View } from "@ctv/shared-core/src";
import { StyleSheet } from "react-native";

type Props = {
  isSubmitting: boolean;
  isVisible: boolean;
  onSubmit(): void;
  onClose(): void;
};

export default function SubmitFormModal({
  isSubmitting,
  isVisible,
  onClose,
  onSubmit,
}: Props) {
  const { CorporateRegistration: cr } = useContentResource();
  return (
    <Modal
      visible={isVisible}
      onClose={onClose}
      render={() => (
        <Card style={[styles.container]}>
          <Text style={styles.spacingM} variant="headline">
            {cr.submitModalTitle}
          </Text>
          <Text style={styles.spacingM} ink="black-secondary">
            {cr.submitModalInfo}
          </Text>
          <View row justify="end">
            <Button
              variant="text-primary"
              text={cr.submitModalCancelButton}
              onPress={onClose}
            />
            <Button
              style={styles.submitButton}
              variant="main-cta"
              text={cr.submitModalSubmitButton}
              onPress={onSubmit}
              loading={isSubmitting}
            />
          </View>
        </Card>
      )}
    />
  );
}

const styles = StyleSheet.create({
  container: {
    padding: Token.spacing.m,
    marginTop: -Token.spacing.xl,
    width: 600,
  },
  spacingM: {
    marginBottom: Token.spacing.m,
  },
  submitButton: {
    paddingHorizontal: Token.spacing.s,
    paddingVertical: Token.spacing.xs,
    marginLeft: Token.spacing.xl,
  },
});
